export const SET_MEMBER = 'SET_MEMBER';
export const CLEAR_MEMBER = 'CLEAR_MEMBER';

export const SET_IDCARD_IMAGE = 'SET_IDCARD_IMAGE';

export const SET_USER_IMAGE = 'SET_USER_IMAGE';